import React, { useState } from 'react';
import { FaChevronUp, FaChevronDown, FaRegEdit } from 'react-icons/fa';
import { usePatchForm } from '../../providers/PatchFormProvider';
import { ENABLE_PATCH_ACTION_UNINSTALL_SOFTWARE } from '../../common/config/featureFlags';

const ActionCard = ({ title, children }) => (
  <div className="bg-[#1e1e1e] p-4 rounded-md border border-white/10 mb-4">
    <h3 className="text-md font-semibold mb-2 text-white">{title}</h3>
    <div className="text-sm text-gray-300">{children}</div>
  </div>
);

const ActionsAccordion = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { patchFormData } = usePatchForm();

  const runscript = patchFormData.RemediationPlanActionList?.find((item) => item.ActionType === 'Script');
  const reboot = patchFormData.RemediationPlanActionList?.find((item) => item.ActionType === 'RebootDevice')?.WhenToExecute;
  const registryKey = patchFormData.RemediationPlanActionList?.find((item) => item.ActionType === 'RegistryUpdate');

  const getRegistryType = (registryType) => {
    switch (registryType) {
      case 'Insert':
        return 'Insert';
      case 'Update':
        return 'Update';
      case 'Delete':
        return 'Delete';
      default:
        return null;
    }
  };

  // Get installed software list
  const installedSoftware = patchFormData.RemediationPlanActionList?.filter((item) => item.ActionType === 'SoftwareInstall')?.map((item) =>
    `${item.PackageIdentifier} ${item.VersionToBeInstalled || ''}`.trim(),
  );

  // Get uninstalled software list
  const uninstalledSoftware = patchFormData.RemediationPlanActionList?.filter((item) => item.ActionType === 'SoftwareUnInstall')?.map(
    (item) => `${item.PackageIdentifier} ${item.VersionToBeUninstalled || ''}`.trim(),
  );

  return (
    <div className="bg-[#111] text-white p-4 rounded-md border border-dashed border-purple-500">
      <div className="flex justify-between items-center mb-4 cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
        <h2 className="text-lg font-bold">ACTIONS</h2>
        <div className="flex items-center gap-2">
          <FaRegEdit className="cursor-pointer hover:text-gray-300" />
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </div>
      </div>

      {isExpanded && (
        <>
          <ActionCard title="Run Script">
            <pre className="text-red-400 text-sm">
              {/* {`print("Custom script executed successfully.")\nprint("Current date and time:", datetime.datetime.now())`} */}
              {runscript?.ScriptName || 'No script found'}
            </pre>
          </ActionCard>

          <ActionCard title="Installed Software">
            {installedSoftware?.length ? (
              <p>
                Software: <span className="text-white">{installedSoftware.join(', ')}</span>
              </p>
            ) : (
              <p>No installed software found</p>
            )}
          </ActionCard>

          {ENABLE_PATCH_ACTION_UNINSTALL_SOFTWARE && (
            <ActionCard title="Uninstalled Software">
              {uninstalledSoftware?.length ? (
                <p>
                  Software: <span className="text-white">{uninstalledSoftware.join(', ')}</span>
                </p>
              ) : (
                <p>No uninstalled software found</p>
              )}
            </ActionCard>
          )}

          <ActionCard title="Reboot Device">
            <p>
              Check Completed: <span className="text-white">{reboot === 'PreRemediation' ? 'Pre Remediation' : 'Post Remediation'} </span>
            </p>
          </ActionCard>

          <ActionCard title="Registry Key">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
              <p>
                <strong>Key Path ending with key name:</strong>
                <br />
                {registryKey?.RegistryKeyPath || 'No key path selected'}
              </p>
              <p>
                <strong>Registry Type:</strong>
                <br />
                {getRegistryType(registryKey?.OperationType) || 'No Type selected'}
              </p>
              <p>
                <strong>Registry Value Name:</strong>
                <br />
                {registryKey?.RegistryKeyValue || 'No keyValue selected'}
              </p>
              <p>
                <strong>Registry Value Data:</strong>
                <br />
                {registryKey?.RegistryKeyName || 'No value data selected'}
              </p>
              <p>
                <strong>Add New Name:</strong>
                <br />
                {registryKey?.OperationType === '1' ? 'True' : 'False'}
              </p>
            </div>
          </ActionCard>
        </>
      )}
    </div>
  );
};

export default ActionsAccordion;
